import React, { useEffect, useState } from 'react';
import { FormControl, InputAdornment, ListItem, ListItemAvatar, ListItemText, TextField, Typography, List, Backdrop, CircularProgress, Pagination } from '@mui/material';
import '../../scss/pages/Rewards/Rewards.scss';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router';
import { REWARDS_HISTORY_PATH, SEND_REWARDS_PATH } from '../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { SPOT_REWARD_AVAILABLE_COINS, SUBORDINATE_SPOT_REWARD } from '../../sagas/type';
import RewardCoinLogo from '../../asset/svg/RewardCoinLogo.svg';
import { getLocalStoreString } from '../../utils/Helper';
import NoDataImage from '../../asset/svg/NoDataImage.svg';

function Rewards() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { spotRewardConfigData, spotRewardCoinsDetails } = useSelector(mapStateToProps);
    const [searchName, setSearchName] = useState('');
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 100; // Number of items per page

    useEffect(() => {
        if (!spotRewardConfigData?.length) {
            getSubordinateSpotReward();
        }
        getAvailableCoins();
    }, []);

    window.addEventListener('employeeDetailsFetch', () => {
        if (!spotRewardConfigData?.length) {
            getSubordinateSpotReward();
        }
        getAvailableCoins();
    });

    const getSubordinateSpotReward = () => {
        setLoader(true);
        dispatch({
            type: SUBORDINATE_SPOT_REWARD,
            setLoader: setLoader,
        });
    };

    const getAvailableCoins = () => {
        setLoading(true);
        const empCode = getLocalStoreString("EmployeeCode");
        dispatch({
            type: SPOT_REWARD_AVAILABLE_COINS,
            payload: { managerCode: empCode },
            setLoading: setLoading,
        });
    };

    const handleSearch = (event) => {
        const { value } = event.target;
        setSearchName(value);
        setCurrentPage(1); // Reset page number when search changes
    };

    const handleListClick = (data) => {
        const empCode = getLocalStoreString("EmployeeCode");
        navigate(SEND_REWARDS_PATH, { state: { singleUserViewedData: data, managerCode: empCode, spotRewardCoinsDetails: spotRewardCoinsDetails } });
    };

    const handleOpenHistory = () => {
        navigate(REWARDS_HISTORY_PATH, { state: { isRoute: "isReward" } });
    };

    // Logic to calculate the index of the first and last item of the current page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    return (
        <div className='rewardsContainer'>
            <div className='rewardsContainer_header'>
                <Typography className='rewardsContainer_header_header1'>Give Rewards</Typography>
                <div>
                    {/* <img className='rewardsContainer_header_rewardCoinsLogo' src={RewardCoinLogo} alt="" />&nbsp;&nbsp;
                    <span className='rewardsContainer_header_rewardCoins'>{spotRewardCoinsDetails?.totalBalance}</span> */}
                    <Typography sx={{ color: "#8074FF", fontWeight: 700, fontSize: "14px", fontFamily: " 'Noto Sans', sans-serif", textAlign: "right", lineHeight: "20px", marginRight: '5px' }} onClick={handleOpenHistory}>History</Typography>
                </div>
            </div>
            <div className='rewardsContainer_searchcontainer'>
                <FormControl sx={{ m: 1, width: '270px', backgroundColor: 'rgba(255,255,255,0.18)', borderRadius: '12px', padding: 1 }}>
                    <TextField size="small" variant="outlined" placeholder='Search' onChange={handleSearch}
                        InputProps={{ startAdornment: (<InputAdornment position='start'> <SearchIcon sx={{ color: 'gray' }} /></InputAdornment>), }} />
                </FormControl>
            </div>
            <div>
                <div className='rewardsContainer_flexBox_ContentMap'>
                    {loader ? <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer - 1 }}
                        open={loader}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop> :
                        <>
                            {spotRewardConfigData && spotRewardConfigData.length > 0 ?
                                <>
                                    {spotRewardConfigData
                                        .filter((element) => element.name.toLowerCase().includes(searchName.toLowerCase()) || element.code.toLowerCase().includes(searchName.toLowerCase()) )
                                        .slice(indexOfFirstItem, indexOfLastItem)
                                        .map((data, index) => ( // Use 'index' as key for mapping when rendering dynamic lists
                                            <List key={index} sx={{ width: "100%", bgcolor: "#021239", }} onClick={() => handleListClick(data)}>
                                                <ListItem alignItems="flex-start" sx={{ borderBottom: "1px solid  rgba(255, 255, 255, 0.1)", padding: "0.5 1rem" }}>
                                                    <ListItemAvatar><img style={{ width: '36px' }} src={data.profileImage} alt="" /> </ListItemAvatar>
                                                    <ListItemText sx={{ color: 'white', fontStyle: 'normal', fontWeight: '600', fontSize: '14px', lineHeight: '17px' }}
                                                        primary={data.name}
                                                        secondary={
                                                            <div style={{ color: 'white' }}>
                                                                <Typography sx={{ display: "inline", fontStyle: 'normal', fontWeight: '400', fontSize: '12px', lineHeight: '12px', color: 'rgba(255,255,255,0.5)' }}
                                                                    component="span" variant="body2" color="white" > {data.code}</Typography>
                                                            </div>
                                                        }
                                                    />
                                                </ListItem>
                                            </List>
                                        ))
                                    }
                                    <Pagination
                                        count={Math.ceil(spotRewardConfigData.length / itemsPerPage)}
                                        page={currentPage}
                                        onChange={(event, page) => setCurrentPage(page)}
                                        className='rewardsContainer_flexBox_ContentMap_pagination'
                                        boundaryCount={1}
                                        sx={{
                                            '& .MuiPaginationItem-page, & .MuiPaginationItem-icon, & .MuiPaginationItem-ellipsis': { color: '#fff' }, '& .MuiPagination-ul': { padding: '8px 0px' }
                                        }} />
                                </>
                                :
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                                    <div className='rewardsContainer_emptyImages' style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                                        <img className='rewardsContainer_noDataImage' style={{ heigth: '54px', width: '68px' }} src={NoDataImage} alt="" />
                                    </div>
                                    <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                                        <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='#FFFFFF' > User Not Found</Typography>
                                    </div>
                                </div>
                            }
                        </>}
                </div>
            </div>
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        spotRewardConfigData: state.spotRewardConfig.spotRewardConfigData,
        spotRewardCoinsDetails: state.spotRewardConfig.spotRewardCoinsDetails
    };
};

export default Rewards;
